import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { products } from '../data/products';

export default function ProductGrid({ addToCart }) {
  const [filter, setFilter] = useState('all');

  const filteredProducts = filter === 'all' 
    ? products 
    : products.filter(p => p.category === filter);

  return (
    <section className="py-24 bg-white" id="shop">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <div>
            <h2 className="text-4xl font-bold text-stone-900 mb-4">Shop the Collection</h2>
            <p className="text-stone-500 text-lg">Everything you need for sustainable hydration.</p>
          </div>
          
          <div className="flex gap-2 p-1 bg-stone-100 rounded-full overflow-x-auto w-full md:w-auto hide-scrollbar">
            {['all', 'bottles', 'accessories', 'bundles'].map(cat => (
              <button
                key={cat}
                onClick={() => setFilter(cat)}
                className={`px-6 py-2 rounded-full text-sm font-medium capitalize whitespace-nowrap transition-colors ${
                  filter === cat ? 'bg-white text-stone-900 shadow-sm' : 'text-stone-500 hover:text-stone-900'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {filteredProducts.map((product, idx) => (
            <motion.div 
              key={product.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="relative aspect-square bg-stone-100 rounded-2xl overflow-hidden mb-4">
                {product.isNew && (
                  <div className="absolute top-4 left-4 z-10 bg-teal-700 text-white text-xs font-bold px-3 py-1 rounded-full">
                    NEW
                  </div>
                )}
                {product.originalPrice && (
                  <div className="absolute top-4 left-4 z-10 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                    SALE
                  </div>
                )}
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover mix-blend-multiply transition-transform duration-500 group-hover:scale-105"
                />
                <button 
                  onClick={(e) => { e.stopPropagation(); addToCart(); }}
                  className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-md text-stone-900 py-3 rounded-xl font-medium opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:bg-stone-900 hover:text-white"
                >
                  Add to Cart
                </button>
              </div>
              
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-bold text-stone-900 text-lg group-hover:text-teal-700 transition-colors">{product.name}</h3>
                  <p className="text-stone-500 text-sm">{product.subtitle}</p>
                </div>
                <div className="text-right">
                  <span className="font-semibold text-stone-900">${product.price}</span>
                  {product.originalPrice && (
                    <span className="block text-sm text-stone-400 line-through">${product.originalPrice}</span>
                  )}
                </div>
              </div>
              
              {product.colors.length > 0 && (
                <div className="flex gap-1.5 mt-3">
                  {product.colors.map(color => (
                    <div 
                      key={color.name} 
                      className="w-4 h-4 rounded-full border border-stone-200"
                      style={{ backgroundColor: color.hex }}
                      title={color.name}
                    />
                  ))}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}